/**
 * File marketo-form.js.
 *
 * Handles marketo form.
 */
(function ($) {
	"use strict";

	/* Load marketo function */
	window.loadMarketoForm = (munchkinId, formId) => {
		if (undefined !== MktoForms2 && "" != formId) {
			var loadForm = MktoForms2.loadForm.bind(
					MktoForms2,
					"//go.efi.com",
					munchkinId,
					formId
				),
				formEls = [].slice.call(
					document.querySelectorAll(
						'.site-main [data-formId="' +
							formId +
							'"]:not(.efi-mk-loaded)'
					)
				);
			(function loadFormCb(formEls) {
				var formEl = formEls.shift();
				$(formEl).html("");
				if (formEl) {
					formEl.id = "mktoForm_" + formId;
				}
				loadForm(function (form) {
					if (!form) {
						console.error("Form is not loaded.");
						return;
					}

					const urlParams = new URLSearchParams(window.location.search);

					let utmSourceURL = urlParams.get('utm_source') || "";
					let utmMediumURL = urlParams.get('utm_medium') || "";
					let utmCampaignURL = urlParams.get('utm_campaign') || "";
					let utmTermURL = urlParams.get('utm_term') || "";
					let utmContentURL = urlParams.get('utm_content') || "";

					let postTitle = form.getFormElem().attr("data-post-title") || null;
					let mktoProducts = form.getFormElem().attr("data-mkto-products") || "NULL";
					let mktoSynctoSalesforce = form.getFormElem().attr("data-mkto-syncto-salesforce") || "Yes";
					let campaignLabel = form.getFormElem().attr("data-campaign-label") || "Corporate - Global - Contact Me";
					let utmSource =  "" === utmSourceURL ? form.getFormElem().attr("data-utm-source") || "" : utmSourceURL;
					let utmMedium =  "" === utmMediumURL ? form.getFormElem().attr("data-utm-medium") || "" : utmMediumURL;
					let utmCampaign = "" === utmCampaignURL ? form.getFormElem().attr("data-utm-campaign") || "" : utmCampaignURL;
					let utmTerm = "" === utmTermURL ? form.getFormElem().attr("data-utm-term") || "" : utmTermURL;
					let utmContent = "" === utmContentURL ? form.getFormElem().attr("data-utm-content") || "" : utmContentURL;
					let buttonLabel = form.getFormElem().attr("data-button-label") || "Submit";
					form.vals({"Product_Area__c": postTitle});
					form.vals({"mktoProducts": mktoProducts});
					form.vals({"mktoSynctoSalesforce": mktoSynctoSalesforce});
					form.vals({"Neolane_Campaign_Label__c": campaignLabel});
					form.vals({"UTM_Source__c": utmSource});
					form.vals({"UTM_Medium__c": utmMedium});
					form.vals({"UTM_Campaign__c": utmCampaign});
					form.vals({"UTM_Term__c": utmTerm});
					form.vals({"UTM_Content__c": utmContent});

					// Styles
					$(".efi_form_wrap .mktoFormRow").each(function () {
						let getColDom = $(this).find(".mktoFormCol").length;
						if (getColDom > 1) {
							$(this).find(".mktoClear").remove();
							$(this).css("display", "flex");
							$(this).css("gap", "20px");
						}
					});

					$(".contact-marketo-form__img").css(
						"height",
						$(".contact-marketo-form__detail").height() + 100
					);
					$(".mktoButtonRow .mktoButtonWrap button").removeClass(
						"mktoButton"
					);
					$(".mktoButtonRow .mktoButtonWrap button").addClass(
						"btn-main"
					);

					// Button label change if found default value
					$('.mktoButtonRow .mktoButtonWrap button').addClass('btn-main');
					if( $(formEl).length ){
						$(formEl).find('.mktoButtonRow .mktoButtonWrap button').html(buttonLabel);
					} else {
						$('.mktoButtonRow .mktoButtonWrap button').html(buttonLabel);
					}

					// Add autocomplete attributes for accessibility (WCAG 1.3.5)
					const autocompleteMap = {
						'FirstName': 'given-name',
						'LastName': 'family-name',
						'Email': 'email',
						'Phone': 'tel',
						'WorkPhone': 'tel',
						'Company': 'organization'
					};

					const formElement = form.getFormElem()[0];
					if (formElement) {
						Object.keys(autocompleteMap).forEach(function(fieldName) {
							const input = formElement.querySelector('input[name="' + fieldName + '"]');
							if (input) {
								input.setAttribute('autocomplete', autocompleteMap[fieldName]);
							}
						});
					}

					// Add an onSuccess handler
					form.onSuccess(function (post_values, redirect) {
						form.getFormElem().addClass("u-hidden");
						form.getFormElem()
							.parent()
							.find(".efi_form_wrap__success-msg")
							.removeClass("u-hidden");

						// Redirect on thank you page.
						let redirectURL =
							form.getFormElem().attr("data-redirect-url") || "";
						if (redirectURL) {
							location.href = redirectURL;
						}

						// Return false to prevent the submission handler continuing with its own processing
						return false;
					});
					if (formEl) {
						formEl.id = "";
					}
					formEls.length && loadFormCb(formEls);
				});
			})(formEls);
		}
	};

	// Marketo form
	var formIds = [];
	var munchkinId = "";
	let marketoScriptDelayTime = 0.1;

	$(".efi_form_wrap").each(function () {
		if ($("form", this).length > 0) {
			munchkinId = $("form", this).attr("data-munchkin") || "";
			var formId = $("form", this).attr("data-formId") || "";
			if ($.inArray(formId, formIds) == -1) {
				formIds.push(formId);
			}
		}
	});
	if (formIds.length > 0) {
		setTimeout(function () {
			let scriptEle = document.createElement("script");
			scriptEle.setAttribute(
				"data-src",
				"https://go.efi.com/js/forms2/js/forms2.min.js"
			);
			scriptEle.setAttribute(
				"data-type",
				"lazy"
			);
			document.body.appendChild(scriptEle);
			scriptEle.addEventListener("load", () => {
				/* util */
				var arrayify = getSelection.call.bind([].slice);
				/* fix inter-form label bug! */
				MktoForms2.whenRendered(function (form) {
					var formEl = form.getFormElem()[0],
						rando = "_" + new Date().getTime() + Math.random();

					arrayify(formEl.querySelectorAll("label[for]")).forEach(
						function (labelEl) {
							var forEl = formEl.querySelector(
								'[id="' + labelEl.htmlFor + '"]'
							);
							if (forEl) {
								labelEl.htmlFor = forEl.id = forEl.id + rando;
							}
						}
					);
					arrayify(formEl.querySelectorAll("label[id]")).forEach(
						function (labelEl) {
							labelEl.id = labelEl.id + rando;
						}
					);
					arrayify(formEl.querySelectorAll("span[id]")).forEach(
						function (spanEl) {
							spanEl.id = spanEl.id + rando;
						}
					);

					// Add autocomplete attributes for accessibility (WCAG 1.3.5)
					const autocompleteMap = {
						'FirstName': 'given-name',
						'LastName': 'family-name',
						'Email': 'email',
						'Phone': 'tel',
						'WorkPhone': 'tel',
						'Company': 'organization'
					};

					if (formEl) {
						Object.keys(autocompleteMap).forEach(function(fieldName) {
							const input = formEl.querySelector('input[name="' + fieldName + '"]');
							if (input) {
								input.setAttribute('autocomplete', autocompleteMap[fieldName]);
							}
						});
					}
				});
				/* Load marketo form */
				formIds.forEach(function (formId) {
					loadMarketoForm(munchkinId, formId);
				});
			});
		}, marketoScriptDelayTime * 1000);
		setTimeout(function () {
			document.querySelectorAll("script[data-type='lazy']").forEach(function (elem) {
				if (!elem.hasAttribute("src")) {
					elem.setAttribute("src", elem.getAttribute("data-src"));
				}
			})
		}, marketoScriptDelayTime * 1000);
	}
})(jQuery);
